import { atom } from 'jotai';

export interface ICampaignBanner {
  /**
   * 活动 Banner 图，对齐端内官号尺寸，即 1125 * 600
   */
  bannerUrl: string;
  title: string;
  campaignId: string;
  buttonText?: string;
}

export const $CampaignBanner = atom<ICampaignBanner[]>([]);
$CampaignBanner.debugLabel = '$CampaignBanner';
